import * as _ from "lodash-es";
import React, { Component } from "react";
import AccessTypesEnum from "../../../../../models/AccessTypesEnum";
import IErrorDTO from "../../../../../models/DTO/IErrorDTO";
import IOnQBOGetClassesDTO from "../../../../../models/DTO/IOnQBOGetClassesDTO";
import IQBOGetClassesDTO from "../../../../../models/DTO/IQBOGetClassesDTO";
import EndpointsEnum from "../../../../../models/EndpointsEnum";
import ICatalog from "../../../../../models/ICatalog";
import IConnection_TokenUI from "../../../../../models/IConnection_TokenUI";
import INotification from "../../../../../models/INotification";
import ISupplierModel from "../../../../../models/ISupplierModel";
import IUserUI from "../../../../../models/IUserUI";
import NotificationLevelEnum from "../../../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../../../models/NotificationPositionEnum";
import IQBOClassDTO from "../../../../../models/QuickBooks Online/IQBOClassDTO";
import UserTypesEnum from "../../../../../models/UserTypesEnum";
import SystemConst from "../../../../../services/SystemConst";
import OwButton from "../../../../shared/OwButton/OwButton";
import OwCheckbox from "../../../../shared/OwCheckbox/OwCheckbox";
import OwInputWrapper from "../../../../shared/OwInputWrapper/OwInputWrapper";
import OwLabel from "../../../../shared/OwLabel/OwLabel";
import OwSelectOption from "../../../../shared/OwSelectOption/OwSelectOption";
import OwTitle from "../../../../shared/OwTitle/OwTitle";
import MasterUser from "../../MasterUser/MasterUser";
import "./SupplierUserSidebar.scss";
import { Socket } from "socket.io-client";
import IUiSocketSetup from "../../../../../models/IUiSocketSetup";
import IOnGetRoutesDTO from "../../../../../models/DTO/IOnGetRoutesDTO";
import IRoute from "../../../../../models/IRoute";
import IGetRoutesDTO from "../../../../../models/DTO/IGetRoutesDTO";
import OwBadge from "../../../../shared/OwBadge/OwBadge";
import Typeahead from "../../../../shared/Typeahead/Typeahead";
import HelperService from "../../../../../services/HelperService";
import OwToggle from "@components/shared/OwToggle/OwToggle";

type Props = {
    cancel: () => void;
    supplierUser?: IConnection_TokenUI;
    catalogs: ICatalog[];
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: INotification, isFormatted?: boolean) => void;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
};

type State = {
    user: any;
    name: string;
    email: string;
    user_type_id?: number | null;
    access_type_id?: number | null;
    price_group_id?: number | null;
    catalog_id?: number | null;
    commission_rate?: number | null;
    is_sales_rep?: boolean | null;
    isFormValid?: boolean;
    hide_pricing: boolean;
    dashboard_order_entry: boolean;
    priceGroups: any[];
    isSaving: boolean;
    qbd_ListID: string | null;
    qbo_InvoiceClassRef: string | null;
    qboClasses: IQBOClassDTO[];
    route_id?: number | null;
    availableRoutes: IRoute[];
    selectedRoute?: IRoute;
};

class SupplierUserSidebar extends Component<Props, State> {
    formEl = React.createRef<HTMLFormElement>();
    showAccessTypeRestrictions = false;
    showCatalogRestrictions = false;

    sockets: IUiSocketSetup[] = [];

    readonly state: State = {
        user: _.get(this.props, "supplierUser.User", {}),
        name: _.get(this.props, "supplierUser.User.name", ""),
        email: _.get(this.props, "supplierUser.User.email", ""),
        user_type_id: _.get(this.props.supplierUser, "user_type_id", null),
        access_type_id: _.get(this.props.supplierUser, "access_type_id", null),
        price_group_id: _.get(this.props.supplierUser, "price_group_id", null),
        catalog_id: _.get(this.props.supplierUser, "catalog_id", null),
        commission_rate: _.get(this.props.supplierUser, "commission_rate", null),
        qbd_ListID: _.get(this.props.supplierUser, "qbd_ListID", null),
        hide_pricing: _.get(this.props.supplierUser, "hide_pricing", false),
        is_sales_rep: _.get(this.props.supplierUser, "is_sales_rep", false),
        qbo_InvoiceClassRef: _.get(this.props.supplierUser, "qbo_InvoiceClassRef", null),
        dashboard_order_entry: _.get(this.props.supplierUser, "dashboard_order_entry", false),
        priceGroups: [],
        isSaving: false,
        qboClasses: [],
        route_id: _.get(this.props.supplierUser, "route_id", null),
        availableRoutes: [],
    };

    constructor(props: any) {
        super(props);

        this.sockets = [
            { endpoint: EndpointsEnum.CatalogsOnGetPriceGroups, fn: this.onGetPriceGroups },
            { endpoint: EndpointsEnum.TokenOnGenerateSupplierUserToken, fn: this.onGenerateSupplierUserToken },
            { endpoint: EndpointsEnum.TokenOnUpdateTokenConfiguration, fn: this.onUpdateTokenConfiguration },
            { endpoint: EndpointsEnum.Notify, fn: this.notify },
            { endpoint: EndpointsEnum.QBOOnGetClasses, fn: this.qboOnGetClasses },
            { endpoint: EndpointsEnum.RoutesOnGetRoutes, fn: this.onGetRoutes },
        ];
    }

    async componentDidMount() {
        // @ts-expect-error
        const isFormValid = this.formEl.current.checkValidity();

        for (const socket of this.sockets) {
            this.props.socket.on(socket.endpoint, socket.fn);
        }

        if (this.props.supplierModel.Supplier_Integration.has_qbo) {
            // this.qboGetClasses();
        }

        this.setState(
            {
                isFormValid,
            },
            () => {
                if (!_.isNil(this.state.catalog_id) && this.state.catalog_id > 0) {
                    const catalog = this.getCatalogById(this.state.catalog_id);
                    if (catalog) {
                        this.getPriceGroups(catalog.guid);
                    }
                }
            }
        );
    }

    componentWillUnmount() {
        for (const socket of this.sockets) {
            this.props.socket.removeListener(socket.endpoint, socket.fn);
        }
    }

    notify = (data: INotification) => {
        this.setState({
            isSaving: false,
        });
    };

    qboGetClasses = () => {
        const payload: IQBOGetClassesDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.QBOGetClasses, payload);
    };

    qboOnGetClasses = (data: IOnQBOGetClassesDTO) => {
        this.setState({
            qboClasses: data.classes,
        });
    };

    getRoutes = (name: string) => {
        const payload: IGetRoutesDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            name,
        };

        this.props.socket.emit(EndpointsEnum.RoutesGetRoutes, payload);
    };

    onGetRoutes = (data: IOnGetRoutesDTO) => {
        this.setState({
            availableRoutes: data.routes,
        });
    };

    getCatalogById = (catalog_id: number): ICatalog | undefined => {
        if (!_.isNumber(catalog_id)) {
            catalog_id = parseInt(catalog_id);
        }

        const foundCatalog = _.find(this.props.catalogs, (catalog: ICatalog) => {
            if (catalog.id === catalog_id) {
                return true;
            }
        });

        // @ts-expect-error
        return foundCatalog;
    };

    onGetPriceGroups = (data: any) => {
        const state: any = {
            priceGroups: data.priceGroups,
            // price_group_id: 0,
        };

        this.setState(state);
    };

    completeUserSetup = (data: any) => {
        const notification: INotification = {
            title: data.message,
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bl,
        };

        this.props.notifyFn(null, notification);

        this.resetState();
        this.cancel();
    };

    onGenerateSupplierUserToken = (data: any) => {
        data["message"] = "created_user_token";
        this.completeUserSetup(data);
    };

    onUpdateTokenConfiguration = (data: any) => {
        data["message"] = "updated_user_token";
        this.completeUserSetup(data);
    };

    resetState = () => {
        this.setState({
            user: {},
            isSaving: false,
        });
    };

    cancel = () => {
        this.props.cancel();
    };

    handleChange = (e: any) => {
        const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        const name = e.target.name;

        // @ts-expect-error
        let isFormValid = this.formEl.current.checkValidity();

        let email = this.state.email;

        if (name === "email") {
            email = value;
        }

        const validEmail = HelperService.validateEmailAddress(email);

        if (!validEmail) {
            isFormValid = false;
        }

        const state: any = {
            [name]: value,
            isFormValid,
        };

        if (name === "is_sales_rep" && value) {
            state.user_type_id = UserTypesEnum.SALES;
            state.access_type_id = AccessTypesEnum.RESTRICTED;
        }

        this.setState(state);
    };

    getAccessLevelDOM = () => {
        if (!_.isNil(this.props.supplierUser) && this.state.user_type_id === SystemConst.userTypes.ADMIN) {
            return "Full";
        } else {
            if (Number(this.state.user_type_id) === SystemConst.userTypes.SALES) {
                const accessOptions = [
                    { value: AccessTypesEnum.FULL, label: "Full" },
                    { value: AccessTypesEnum.RESTRICTED, label: "Restricted" },
                    { value: AccessTypesEnum.READ_ONLY, label: "Read Only" },
                ];

                return (
                    <OwSelectOption
                        options={accessOptions}
                        valueProp={"value"}
                        titleProp={"label"}
                        name={"access_type_id"}
                        selectedOption={this.state}
                        selectedOptionProp={"access_type_id"}
                        fn={this.handleChange}
                        isRequired={this.showAccessTypeRestrictions}
                        showBlankFirst={true}
                        isDisabled={!!this.state.is_sales_rep}
                    />
                );
            }
        }
    };

    getUserTypeDOM = () => {
        if (!_.isNil(this.props.supplierUser) && this.props.supplierUser.is_master) {
            return "Admin";
        } else {
            const options = [
                { value: SystemConst.userTypes.ADMIN, label: "Admin" },
                { value: SystemConst.userTypes.SALES, label: "Sales" },
                { value: SystemConst.userTypes.INVENTORY_MGMT, label: "Inventory Mgmt." },
                { value: SystemConst.userTypes.ORDER_MGMT, label: "Order Mgmt." },
                { value: SystemConst.userTypes.SHIP_MGMT, label: "Ship Mgmt." },
                { value: SystemConst.userTypes.DRIVER, label: "Driver" },
            ];

            const user_type_id = _.get(this.props.supplierUser, "user_type_id", null);

            // we have to fake the option value with an object
            const user_type = {
                user_type_id,
            };

            return (
                <OwSelectOption
                    options={options}
                    valueProp={"value"}
                    titleProp={"label"}
                    name={"user_type_id"}
                    selectedOption={this.state}
                    selectedOptionProp={"user_type_id"}
                    fn={this.handleChange}
                    isRequired={true}
                    showBlankFirst={true}
                    isDisabled={!!this.state.is_sales_rep}
                />
            );
        }
    };

    getPriceGroups = (catalogGuid: string) => {
        if (this.props.userModel && this.props.supplierModel) {
            const payload = {
                userToken: this.props.userModel.token,
                userGuid: this.props.userModel.guid,
                supplierGuid: this.props.supplierModel.guid,
                catalogGuid: catalogGuid,
            };

            this.props.socket.emit("getPriceGroups", payload);
        }
    };

    lockCatalog = (e: any) => {
        this.handleChange(e);

        const catalog_id = parseInt(e.target.value);

        const catalog = this.getCatalogById(catalog_id);

        if (catalog) {
            this.getPriceGroups(catalog.guid);
        }
    };

    saveUser = () => {
        if (this.props.userModel && this.props.supplierModel) {
            const payload: any = {
                userToken: this.props.userModel.token,
                userGuid: this.props.userModel.guid,
                supplierGuid: this.props.supplierModel.guid,
                catalog_id: this.state.catalog_id,
                price_group_id: this.state.price_group_id,
                user_type_id: this.state.user_type_id,
                access_type_id: this.state.access_type_id,
                commission_rate: this.state.commission_rate,
                hide_pricing: this.state.hide_pricing,
                name: this.state.name,
                email: this.state.email,
                is_sales_rep: this.state.is_sales_rep,
                qbd_ListID: this.state.qbd_ListID,
                qbo_InvoiceClassRef: this.state.qbo_InvoiceClassRef,
                dashboard_order_entry: this.state.access_type_id === AccessTypesEnum.READ_ONLY ? false : this.state.dashboard_order_entry,
                route_id: this.state.selectedRoute ? this.state.selectedRoute.id : this.state.route_id,
            };

            if (!_.isNil(this.props.supplierUser)) {
                payload["tokenGuid"] = this.props.supplierUser.guid;

                this.props.socket.emit(EndpointsEnum.TokenUpdateTokenConfiguration, payload);
            } else {
                this.props.socket.emit(EndpointsEnum.TokenGenerateSupplierUserToken, payload);
            }

            this.setState({
                isSaving: true,
            });
        }
    };

    cancelUser = () => {
        this.resetState();
        this.cancel();
    };

    render() {
        let header = "create_supplier_user";
        let isNewUser = true;

        if (!_.isNil(this.props.supplierUser) && this.props.supplierUser.guid) {
            header = "update_supplier_user";
            isNewUser = false;
        }

        const accessLevelDOM = this.getAccessLevelDOM();

        const userTypeDOM = this.getUserTypeDOM();

        const catalogs = _.get(this.props, "catalogs", []);

        let priceGroups;

        if (catalogs.length === 1) {
            priceGroups = catalogs[0].Price_Groups;
        } else {
            priceGroups = this.state.priceGroups;
        }

        let user_type_id: any = _.get(this.state, "user_type_id", null);

        user_type_id = parseInt(user_type_id);

        let access_type_id: any = _.get(this.state, "access_type_id", null);

        access_type_id = parseInt(access_type_id);

        this.showAccessTypeRestrictions = false;

        this.showCatalogRestrictions = false;

        if (user_type_id > 0) {
            if (user_type_id === SystemConst.userTypes.SALES) {
                this.showAccessTypeRestrictions = true;
            }
        }

        if (access_type_id > 0) {
            if (access_type_id !== SystemConst.accessTypes.FULL) {
                this.showCatalogRestrictions = true;
            }
        }

        const isMasterUser = _.get(this.props, "supplierUser.is_master", false);

        let hidePricingOption: any = null;

        let isSalesRepCheckbox: any = null;

        if (this.props.supplierModel && this.props.supplierModel.has_hide_pricing) {
            hidePricingOption = (
                <div className={"mt-2"}>
                    <OwToggle
                        labelOnRight={true}
                        label={"hide_pricing"}
                        name={"hide_pricing"}
                        fn={this.handleChange}
                        active={this.state.hide_pricing}
                        disabled={this.state.access_type_id === AccessTypesEnum.READ_ONLY}
                    />
                </div>
            );
        }

        if (this.props.supplierModel.has_rep_groups && this.state.user_type_id !== UserTypesEnum.ADMIN) {
            isSalesRepCheckbox = (
                <div className={"mt-2"}>
                    <OwToggle
                        labelOnRight={true}
                        label={"is_sales_rep"}
                        fn={this.handleChange}
                        name={"is_sales_rep"}
                        active={!!this.state.is_sales_rep}
                        disabled={this.state.access_type_id === AccessTypesEnum.READ_ONLY}
                    />
                </div>
            );
        }

        let qbdSalesRepOptions: { ListID: string; FullName: string }[] = [];

        if (this.props.supplierModel.Supplier_Integration.has_qbd && this.props.supplierModel.Supplier_Integration.qbd_SalesReps) {
            let salesRepDetailsArr: {
                ListID: string;
                Initial: string;
                IsActive: string;
                SalesRepEntityRef: { FullName: string; ListID: string };
            }[] = [];

            if (_.isString(this.props.supplierModel.Supplier_Integration.qbd_SalesReps)) {
                salesRepDetailsArr = JSON.parse(this.props.supplierModel.Supplier_Integration.qbd_SalesReps);
            } else {
                salesRepDetailsArr = this.props.supplierModel.Supplier_Integration.qbd_SalesReps;
            }

            qbdSalesRepOptions = salesRepDetailsArr.map((detail) => {
                return {
                    ListID: detail?.ListID || "",
                    FullName: detail?.SalesRepEntityRef?.FullName || "",
                };
            });
        }

        return (
            <div className="SupplierUserSidebar" style={{ height: "100vh", overflow: "hidden" }}>
                <div className={"p-3"} style={{ height: "15vh" }}>
                    <div className="text-end">
                        <button className="btn btn-danger btn-sm" onClick={this.cancel}>
                            <i className="far fa-times" />
                        </button>
                    </div>
                    <OwTitle className={"mb-2"} leftIconName={"fas fa-user"} title={header} />
                    <hr />
                </div>

                <div className={"p-3"} style={{ height: "85vh", overflowY: "scroll" }}>
                    <form ref={this.formEl}>
                        {/*<div>*/}
                        {/*    <OwLabel title={"name"} />*/}
                        {/*    <OwInputWrapper placeholder={"name"} name={"name"} value={this.state.name} fn={this.handleSupplierChange} isRequired={true} />
                        {/*</div>*/}
                        {isNewUser ? null : (
                            <div className={"mb-2"}>
                                <OwLabel title={"name"} />
                                <div>{this.state.name}</div>
                            </div>
                        )}

                        <div>
                            <OwLabel title={"email"} />
                            {isNewUser ? (
                                <OwInputWrapper
                                    placeholder={"email"}
                                    name={"email"}
                                    value={this.state.email}
                                    fn={this.handleChange}
                                    isRequired={true}
                                    type={"email"}
                                />
                            ) : (
                                <div>{this.state.email}</div>
                            )}
                        </div>

                        {isSalesRepCheckbox}

                        <div className={isMasterUser ? "d-none" : ""}>
                            <div>
                                <OwLabel title={"user_type"} />
                                {userTypeDOM}
                            </div>

                            <div className={!this.showAccessTypeRestrictions ? "d-none" : ""}>
                                <div>
                                    <OwLabel title={"access_type"} />
                                    {accessLevelDOM}
                                </div>

                                <div className={!this.showCatalogRestrictions ? "d-none" : ""}>
                                    <div>
                                        <OwLabel title={"catalog"} />
                                        <OwSelectOption
                                            options={catalogs}
                                            valueProp={"id"}
                                            titleProp={"name"}
                                            selectedOption={this.state}
                                            selectedOptionProp={"catalog_id"}
                                            fn={(e: any) => {
                                                this.lockCatalog(e);
                                            }}
                                            name={"catalog_id"}
                                            showBlankFirst={true}
                                        />
                                    </div>

                                    <div>
                                        <OwLabel title={"price_group"} />
                                        <OwSelectOption
                                            options={priceGroups}
                                            valueProp={"id"}
                                            selectedOption={this.state}
                                            selectedOptionProp={"price_group_id"}
                                            titleProp={"value"}
                                            fn={(e: any) => {
                                                this.handleChange(e);
                                            }}
                                            name={"price_group_id"}
                                            showBlankFirst={true}
                                        />
                                    </div>
                                </div>
                            </div>

                            {hidePricingOption}
                        </div>

                        <div>
                            <OwLabel title={"commission_rate_perc"} />
                            <OwInputWrapper
                                placeholder={"commission_rate"}
                                name={"commission_rate"}
                                value={this.state.commission_rate}
                                fn={this.handleChange}
                                type={"number"}
                            />
                        </div>

                        <div className={"mt-2 mb-2"}>
                            <OwToggle
                                labelOnRight={true}
                                label={"dashboard_order_entry"}
                                name={"dashboard_order_entry"}
                                fn={this.handleChange}
                                active={this.state.dashboard_order_entry}
                                disabled={this.state.access_type_id === AccessTypesEnum.READ_ONLY}
                            />
                        </div>

                        {/* {this.props.supplierModel.has_routes ? (
                            <div className={"mt-2 mb-2"}>
                                <div>
                                    <OwLabel title={"route"} />
                                </div>
                                <Typeahead
                                    outerWrapperClassName={"w-100"}
                                    isSelectableFn={() => {
                                        return true;
                                    }}
                                    typeaheadApiFn={this.getRoutes}
                                    itemsRenderFn={(data: IRoute) => {
                                        return (
                                            <div>
                                                <div>
                                                    {data.name}
                                                    {data.is_pickup ? <OwBadge title={"pickup"} bgColor={"bg-primary"} /> : null}
                                                </div>
                                            </div>
                                        );
                                    }}
                                    titleProp={"name"}
                                    selectedItem={this.state.selectedRoute}
                                    selectedItemTitleProp={"name"}
                                    typeaheadItems={this.state.availableRoutes}
                                    selectedItemFn={(data: IRoute) => {
                                        this.setState({
                                            selectedRoute: data,
                                        });
                                    }}
                                />
                            </div>
                        ) : null} */}

                        {this.props.supplierModel.Supplier_Integration.has_qbd ? (
                            <div>
                                <OwLabel title={"qbd_sales_rep"} />
                                <OwSelectOption
                                    options={qbdSalesRepOptions}
                                    titleProp={"FullName"}
                                    valueProp={"ListID"}
                                    selectedOption={this.props.supplierUser}
                                    selectedOptionProp={"qbd_ListID"}
                                    name={"qbd_ListID"}
                                    fn={this.handleChange}
                                />
                            </div>
                        ) : null}

                        <div className={isMasterUser ? "mt-2" : "d-none"}>
                            <MasterUser isMaster={isMasterUser} icon={"fas fa-key"} />
                        </div>

                        <div className={"mt-2"}>
                            <OwButton
                                className={"btn-success me-2"}
                                fn={() => {
                                    this.saveUser();
                                }}
                                title={"save"}
                                disabled={!this.state.isFormValid}
                                active={this.state.isSaving}
                            />

                            <OwButton className={"btn-danger"} fn={this.cancelUser} title={"cancel"} />
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}

export default SupplierUserSidebar;
